import { render, staticRenderFns } from "./ValidatedOfferCard.vue?vue&type=template&id=187bb882&scoped=true&"
import script from "./ValidatedOfferCard.vue?vue&type=script&lang=js&"
export * from "./ValidatedOfferCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187bb882",
  null
  
)

export default component.exports